/* eslint-disable react/no-unescaped-entities */
import {React} from "react";

import   "./styles.css";




const Payments = () => {

     return (
      <div style={{background:"#eceff3f6"}}>
        <h1 className="boldFancyHeadFontCenter">
          How to pay for membership and events
        </h1>
        <br/>
        <br/>
        <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>
          There are 2 methods for payment that are accepted by the Kermis Dance Club.<br/>
          Payment by check (which can be mailed to our treasurer - address on the renewal or event invite)<br/>
          Or <br/>
          Electronic payment via the Zelle application.<br/>
          <br/>
          While Zelle does not have its own application that you can use, you can use Zelle via online access to your bank.<br/>
          If you have used Zelle on your phone banking app, you probably already know how to do this<br/>
          and only need to know the Kermis payment email address:  <br/>
          kermispayments@gmail.com<br/>
          <br/>
          If you prefer to use a computer for online banking, the following instructions may be useful.<br/>
          <br/>
          To make a payment with Zelle on a PC, you must use your financial institution's online banking website, as Zelle does not have a standalone desktop app or website.<br/>
          Most major banks (Wells Fargo, Chase, Bank of America, PNC) have Zelle integrated directly into their desktop platforms. <br/>
          Please follow these Step-by-Step Instructions for Using Zelle on a PC<br/>
          <br/>
        </div>
              <ol className={`blackBodyFontLeftLargeBold`} type="A" style={{marginLeft: "auto",marginRight:"auto",width:"60%"}}>
                  <li>
                    Log in to Online Banking
                  </li>
                  <ol type="1">
                    <li>
                      Open your web browser and navigate to your bank's official website.
                    </li>
                    <li>
                      Sign in with your user ID and password.
                    </li>
                  </ol>
                  <li>
                    Locate the Zelle Section
                  </li>
                  <ol type="1">
                    <li>
                      Look for menu options labeled "Pay & Transfer," "Transfer & Pay," or "Bill Pay".
                    </li>
                    <li>
                      Select the option for "Send Money with Zelle®" or "Send & Request Money with Zelle®".
                    </li>
                  </ol>
                  <li>
                    Enroll in Zelle (First Time Only)
                  </li>
                  <ol type="1">
                    <li>
                      If you have never used Zelle, follow the prompts to enroll.
                    </li>
                     <li>
                      You will be asked to accept the terms and conditions.
                    </li>
                    <li>
                      Enter your U.S. mobile number or email address and link a bank account.
                    </li>
                    <li>
                      Verify your identity using a one-time passcode sent to your phone or email.
                    </li>
                  </ol>
                <li>End of First Time Only steps</li>
                <li>
                  Add or Select a Recipient
                </li>
                <ol type="1">
                  <li>
                    Click "Send" or "Add Recipient".
                  </li>
                  <li>
                    Enter the recipient's name (Kermis Club) and email address(kermispayments@gmail.com).
                  </li>
                </ol>
                <li>
                  Enter Amount and Review
                </li>
                <ol type="1">
                  <li>
                    Enter the amount you wish to send.
                  </li>
                  <li>
                    Select the account you want to use to fund the payment.
                  </li>
                  <li>
                    Review the recipient's information carefully to ensure it is correct.
                  </li>
                  <li>
                    Note: For the first time sending to a new recipient, you may need to enter an additional verification code.
                  </li>
                </ol>
                <li>
                  Send the Payment
                </li>
                  <ol type="1">
                    <li>
                      Click "Send" or "Confirm".
                    </li>
                    <li>
                      The recipient will receive a notification and, if enrolled, the money will arrive in their account within minutes. 
                    </li>
                  </ol>  
              </ol>     
              <br/>
              <br/> 
      </div>
     )
   };
   
   export default Payments;